<template>
  <div v-if="amReady">
    {{ formTitle }}
    <panelKeysInfo></panelKeysInfo>
    <el-dialog :append-to-body="true" :visible.sync="dialogVisible" @close="setVendorDestinationStatus" class="call-test-results-dialog" title=""
               top="5vh" width="98%">
      <callTestResultsTable :broadcastPublicId="broadcastPublicId" :liveDataResults='liveDataResults'
                            v-if="dialogVisible"></callTestResultsTable>
    </el-dialog>

    <el-dialog :append-to-body="true" :close-on-click-modal="false"
               :close-on-press-escape="false" :visible.sync="vendorDestinationStatusDialogVisible" class="call-test-results-dialog" title=""
               top="4vh" width="300px">
      <vendorDestinationStatus :broadcast="broadcast"
                               @closeModel="closeVendorDestinationStatus"
                               v-if="vendorDestinationStatusDialogVisible && broadcast.call_test_status_id == 1"></vendorDestinationStatus>
    </el-dialog>

    <div class="p-3">
      <div class="row">
        <div class="col-12 col-md-6 pt-2">
          <span class="ag-grid-quick-search-label">Search</span>
          <span><el-input class="d-inline-block w-50" size='mini' v-model="userSearch"></el-input></span>
        </div>
        <div class="col-12 col-md-6">
          <pagination
              :currentPage="currentPage"
              :margin-pages="2"
              :navigateHandler="navigateToPage"
              :page-count="getPagesCount()"
              :page-range="4"
              paginateClass=""></pagination>
        </div>
      </div>
    </div>

    <app-ag-grid :agGrid="agGrid"></app-ag-grid>
  </div>
</template>

<script>
import Vue from 'vue'
import agGridButton from '@/components/ag-grid-button/View'
import callTestStatusViewer from '@/components/call-test-status-viewer/View'

import module from './../../index.js'
import {notify} from '@/system-services/notify.js'
import {mapActions} from "vuex";
import {getLS} from 'devegram-javascript-util'
import panelMixin from "@/app/portals/cpanel/mixins/util";

export default {
  mixins: [panelMixin],
  watch: {
    userSearch: function (val) {
      this.agGrid.gridApi.setQuickFilter(val);
    }
  },
  components: {
    panelKeysInfo: () => import('@/components/system-table-keys-info/TestingHistory'),
    callTestResultsTable: () => import('@/components/call-test-results-table/View'),
    vendorDestinationStatus: () => import('./../../vendor-destination-status/View'),
    // callTestResults: () => import('./../../call-test-results/View'),
    pagination: () => import('@/components/pagination/View.vue'),
    /*moduleListLayout: () => import('@/modules-config/layouts/list/View.vue')*/
  },
  props: {
    formTitle: {
      required: false,
      default: ''
    },
    userId: {
      default: false
    },
    statusId: {
      required: true,
      type: Number
    }
  },
  data() {
    return {
      defaultRouteDivision: this.$route.params.division,
      isUserReseller: $store.getters['user-state/isUserReseller'],
      isUserCustomer: $store.getters['user-state/isUserCustomer'],
      broadcastPublicId: null,
      callsStatusToView: 0,
      amReady: false,
      broadcast: null,
      liveDataResults: [],
      module: {
        ...module
      },
      userSearch: null,
      currentPage: 1,
      pageChunkSize: 12,
      pageCount: 1,
      profilesList: [],
      editMode: false,
      dialogVisible: false,
      vendorDestinationStatusDialogVisible: false,
      recordsCounter: 0,
      dataToBind: null,
      rowToEdit: null,
      agGrid: {
        pagination: false,
        enableRtl: this.$langConfig.dir == 'rtl',
        agGridStyle: 'width: 100%; height: 650px; padding: 0',
        agGridClass: 'ag-theme-material',
        gridOptions: {
          suppressCellSelection: true,
          onGridReady: function (params) {
            params.api.sizeColumnsToFit()
          }
        },
        columnDefs: [
          {
            field: 'prefix',
            headerName: 'Prefix',
            width: 100,
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'destination',
            width: 140,
            headerName: 'Destination',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'dialcode',
            width: 120,
            headerName: 'Dialcode',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'rate',
            width: 120,
            headerName: 'Rate',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          },
          {
            field: 'execution_time',
            width: 120,
            headerName: 'Execution Time',
            headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
            autoHeight: true
          }
        ],
        rowData: []
      }
    };
  },
  beforeMount() {

    if (!this.isUserCustomer) {
      this.agGrid.columnDefs.push({
        field: 'status',
        width: 120,
        headerName: 'Status',
        headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
        autoHeight: true,
        cellRendererFramework: Vue.extend(callTestStatusViewer),
        cellRendererParams: {
          props: {
            actionsHandler: this.actionsHandler
          }
        }
      })
    }

    this.agGrid.columnDefs.push({
      width: 100,
      headerName: this.$ml.get('actions'),
      headerClass: this.$langConfig.lang + '-lang-text text-capitalize',
      cellRendererFramework: Vue.extend(agGridButton),
      cellRendererParams: {
        props: {
          action: this.viewCallTestResults,
          icon: 'el-icon-view',
          text: '',
          style: ''
        }
      }
    })


    this.callsStatusToView = this.statusId
    this.currentPage = parseInt(this.$route.params.listPage)

    this.panelMixin_getUserVoipDivision('divisionsList', (r) => {
      for (let d in r) {
        if (r[d].label == this.defaultRouteDivision) {
          this.defaultRouteDivision = r[d].label_2
        }
      }
      this.getGridData(this.currentPage)
      this.amReady = true
    })
  },
  methods: {
    getGridData(page) {
      this.panelMixin_getBroadcastHistory({
        userId: this.getUser(),
        page: page,
        statusId: this.callsStatusToView,
        division: this.defaultRouteDivision
      }, response => {
        this.agGrid.rowData = response.data.rows;
        this.recordsCounter = response.data.count;
        this.amReady = true
      })
    },
    getUser() {
      let userId = this.userId
      if (!userId) {
        userId = getLS('user').id
      }
      return userId
    },
    closeVendorDestinationStatus(newStatus) {
      this.vendorDestinationStatusDialogVisible = false
      if (this.statusId == 1 && newStatus != 1) {
        this.agGrid.rowData.splice(this.rowToEdit, 1);
      }
    },
    ...mapActions('voip-testing-panel-state', ['getEntityRecords']),
    ...mapActions('voip-testing-panel-api', {
      getBroadcastCdr: 'getBroadcastCdr'
    }),
    viewCallTestResults(data, props, rowIndex) {
      this.rowToEdit = rowIndex;
      this.broadcast = data
      this.liveDataResults = []
      this.broadcastPublicId = data.public_id
      this.showLiveResults(this.broadcast.id)
      this.dialogVisible = true
    },
    showLiveResults(broadcastId) {
      let apiData = {id: broadcastId}
      if ($store.getters['user-state/isUserMrtEnterprise']) {
        apiData.mrt = true
      }
      this.getBroadcastCdr(apiData).then(response => {
        let cdr = response.data
        this.liveDataResults = JSON.parse(cdr.cdr_json)

      })
    },
    setVendorDestinationStatus() {
      if (this.broadcast.call_test_status_id == "1" && !this.isUserCustomer) {
        this.vendorDestinationStatusDialogVisible = true
      }
    },
    scrollToTop() {
      document.body.scrollTop = 0;
      document.getElementById('content-main-container').scrollTop = 0;
    },
    getPagesCount() {
      return Math.ceil(this.recordsCounter / this.pageChunkSize)
    },
    navigateToPage(page) {
      //$router.push({name : 'module->voip-testing-panel->panel-tabs->tab->list->page', params: {tabName: this.$route.params.tabName, listPage: page}})
      this.getGridData(page)
    },
    refreshGrid() {
      this.agGrid.gridOptions.api.setRowData(this.agGrid.rowData)
    },
    afterEdit(updatedData) {
      // getting a rowNode by index
      // this.agGrid.gridApi.getDisplayedRowAtIndex(0).setData({})

      this.agGrid.rowData[this.rowToEdit] = updatedData;
      this.dialogVisible = false;
      this.refreshGrid();
    },
    afterCreate(newEntity) {
      this.agGrid.rowData.push(newEntity);
      this.dialogVisible = false;
      this.refreshGrid();
    },
    createAction(params) {
      this.dialogVisible = true;
      this.editMode = false;
      this.dataToBind = null;
      this.rowToEdit = null;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    editAction(params) {
      this.dialogVisible = true;
      this.editMode = true;
      this.dataToBind = params.data;
      this.rowToEdit = params.rowIndex;
      // this.$router.push({ name: 'esb-individual-teacher-view', params: { teacherId: params.data.id}})
    },
    removeAction(params) {
      this.$store.dispatch(this.module.info.name + '-api/remove', {id: params.data.id}).then(response => {
        this.agGrid.rowData.splice(params.rowIndex, 1);
        this.refreshGrid();
        this.recordsCounter -= 1;
        notify({
          type: 'success',
          title: this.$ml.get('deleted'),
        });
      })
    },
    actionsHandler(command, params) {
      this[command](params)
    }
  }
}
</script>
